'use client'

import { useRef, useState, useCallback } from 'react'
import { useAnimationFrame } from 'framer-motion'
import { cn } from '@/lib/utils'

interface InfiniteSliderProps {
  children: React.ReactNode
  speed?: number
  speedOnHover?: number
  gap?: number
  className?: string
}

export function InfiniteSlider({
  children,
  speed = 40,
  speedOnHover,
  gap = 64,
  className,
}: InfiniteSliderProps) {
  const [hovered, setHovered] = useState(false)
  const offsetRef = useRef(0)
  const innerRef = useRef<HTMLDivElement>(null)

  useAnimationFrame((_, delta) => {
    const el = innerRef.current
    if (!el) return
    const halfWidth = el.scrollWidth / 2
    if (halfWidth === 0) return
    const currentSpeed = hovered && speedOnHover != null ? speedOnHover : speed
    offsetRef.current += (currentSpeed * delta) / 1000
    if (offsetRef.current >= halfWidth) {
      offsetRef.current -= halfWidth
    }
    el.style.transform = `translateX(-${offsetRef.current}px)`
  })

  return (
    <div
      className={cn('overflow-hidden', className)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div ref={innerRef} className="flex w-max items-center" style={{ gap: `${gap}px` }}>
        {children}
        {children}
      </div>
    </div>
  )
}
